import axios from 'axios';
/**
 * Watad API HTTP client.
 * All requests go through NestJS backend — NOT directly to Supabase.
 */
const apiClient = axios.create({
    baseURL: '/api/v1',
    timeout: 30_000,
    headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
    },
    withCredentials: true,
});
// ─── Request interceptor: attach auth token ────────────────────────────────
apiClient.interceptors.request.use((config) => {
    const token = localStorage.getItem('watad_access_token');
    if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
}, (error) => Promise.reject(error));
// ─── Response interceptor: normalize errors ────────────────────────────────
apiClient.interceptors.response.use((response) => response, async (error) => {
    if (error.response?.status === 401) {
        localStorage.removeItem('watad_access_token');
    }
    // Normalize error shape
    const apiError = error.response?.data ?? {
        code: 'NETWORK_ERROR',
        message: error.message || 'Network error',
        traceId: '',
    };
    const normalizedError = new Error(apiError.message);
    normalizedError.code = apiError.code;
    normalizedError.details = apiError.details;
    normalizedError.traceId = apiError.traceId;
    normalizedError.status = error.response?.status ?? 0;
    return Promise.reject(normalizedError);
});
export { apiClient };
//# sourceMappingURL=api-client.js.map